import { request } from '../common/request'

export const getMerchantInfo = () => {
  return request({
    method: 'post',
    url: '/api/zhaoshang/enter/state'
  })
}

export const getUserInfo = data => {
  return request({
    method: 'get',
    url: '/api/zhaoshang/getLoginStatus',
    params: data
  })
}
